<!-- Admin view: show budget list -->
<app-budget-list
  *ngIf="userRole === 'admin' && currentView === 'landing' && !showMyBudget"
  (viewBudget)="onAdminViewBudget($event)"
  (openMyBudget)="switchToMyBudgetView()"
></app-budget-list>

<div class="budget-container" [class.editor-active]="currentView === 'editor'">
  <!-- Landing View -->
  <div *ngIf="currentView === 'landing' && (userRole !== 'admin' || showMyBudget)" class="landing-view">
    <div *ngIf="showMyBudget" style="margin-bottom: 12px;">
      <button nz-button (click)="backToAdminList()">
        ← Înapoi la lista de bugete
      </button>
    </div>
    <h2 nz-typography class="landing-title">Buget</h2>
    <div class="landing-cards">
      <!-- No budget exists: show only Creează -->
      <ng-container *ngIf="budgetGroups.length === 0">
        <div class="landing-card card-create" (click)="goToCreate()">
          <div class="card-icon">
            <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
          </div>
          <div class="card-title">Creează Buget</div>
          <div class="card-subtitle">Creează un buget nou sau pe baza unui istoric</div>
        </div>
      </ng-container>

      <!-- Budget exists: show Editează Realist + Editează Pesimist + Variații -->
      <ng-container *ngIf="budgetGroups.length > 0">
        <div class="landing-card card-edit" (click)="goToEditRealist()">
          <div class="card-icon">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </div>
          <div class="card-title">Editează Buget Realist</div>
          <div class="card-subtitle">Modifică bugetul realist</div>
        </div>
        <div class="landing-card card-pessimist" (click)="goToEditPesimist()">
          <div class="card-icon">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </div>
          <div class="card-title">Editează Buget Pesimist</div>
          <div class="card-subtitle">Modifică bugetul pesimist</div>
        </div>
        <div class="landing-card card-comparison" (click)="goToComparison()">
          <div class="card-icon">
            <i nz-icon nzType="bar-chart" nzTheme="outline"></i>
          </div>
          <div class="card-title">Variații Bugetare</div>
          <div class="card-subtitle">Compară Realizat vs. Bugetat pe luna aleasă</div>
        </div>
        <div class="landing-card card-delete"
             nz-popconfirm
             nzPopconfirmTitle="Ești sigur că vrei să ștergi bugetul? Toate datele vor fi pierdute."
             nzPopconfirmPlacement="bottom"
             nzOkText="Da, șterge"
             nzCancelText="Anulează"
             nzOkDanger
             (nzOnConfirm)="deleteBudget(budgetGroups[0].realistic?.id || budgetGroups[0].pessimistic?.id)">
          <div class="card-icon">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </div>
          <div class="card-title">Șterge Buget</div>
          <div class="card-subtitle">Elimină bugetul curent pentru a crea unul nou</div>
        </div>
      </ng-container>
    </div>

    <!-- Budget guidance info card -->
    <div *ngIf="budgetGuidanceContent" class="guidance-card" style="margin-top: 24px;">
      <nz-collapse>
        <nz-collapse-panel
          nzHeader="Informații suplimentare pentru întocmirea bugetului"
          [nzActive]="false">
          <div [innerHTML]="budgetGuidanceContent"></div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>

  <!-- Create Budget View -->
  <div *ngIf="currentView === 'create'">
    <div class="budget-header">
      <div>
        <button nz-button (click)="backToLanding()" style="margin-right: 12px;">
          ← Înapoi
        </button>
        <span class="budget-title">Creează Buget</span>
      </div>
    </div>

    <!-- Method selection cards -->
    <div *ngIf="createMethod === 'none'" class="method-cards">
      <div class="method-card method-card-zero" (click)="selectCreateMethod('zero')">
        <div class="method-card-icon">
          <i nz-icon nzType="file-add" nzTheme="outline"></i>
        </div>
        <div class="method-card-title">De la Zero</div>
        <div class="method-card-subtitle">Completezi manual toate valorile</div>
      </div>
      <div class="method-card method-card-historic" (click)="selectCreateMethod('historic')">
        <div class="method-card-icon">
          <i nz-icon nzType="history" nzTheme="outline"></i>
        </div>
        <div class="method-card-title">Pe baza unui Istoric din Rapoarte</div>
        <div class="method-card-subtitle">Veniturile și cheltuielile sunt precompletate dintr-o perioadă aleasă de tine</div>
      </div>
    </div>

    <!-- Inline create form -->
    <div *ngIf="createMethod !== 'none'" class="create-form-container">
      <button nz-button (click)="createMethod = 'none'" style="margin-bottom: 20px;">
        ← Schimbă metoda
      </button>

      <div nz-form nzLayout="vertical" class="create-form">
        <nz-form-item>
          <nz-form-label>Nume buget</nz-form-label>
          <nz-form-control>
            <input nz-input [(ngModel)]="createForm.name" placeholder="ex: Budget 2026" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="createMethod === 'historic'">
          <nz-form-label>Raport sursă</nz-form-label>
          <nz-form-control>
            <nz-select
              [(ngModel)]="createForm.sourceProcessId"
              nzPlaceHolder="Selectează raportul sursă"
              [nzLoading]="loadingFiles"
              nzShowSearch
              nzAllowClear
              style="width: 100%;"
            >
              <nz-option
                *ngFor="let f of userFiles"
                [nzValue]="f.id"
                [nzLabel]="getFileLabel(f)"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <div nz-row [nzGutter]="16">
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>Perioadă start</nz-form-label>
              <nz-form-control>
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="14">
                    <nz-select [(ngModel)]="createForm.periodStartMonth" style="width: 100%;">
                      <nz-option *ngFor="let m of monthsFull" [nzValue]="m.value" [nzLabel]="m.label"></nz-option>
                    </nz-select>
                  </div>
                  <div nz-col [nzSpan]="10">
                    <input nz-input type="number" [(ngModel)]="createForm.periodStartYear" />
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>Perioadă sfârșit</nz-form-label>
              <nz-form-control>
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="14">
                    <nz-select [(ngModel)]="createForm.periodEndMonth" style="width: 100%;">
                      <nz-option *ngFor="let m of monthsFull" [nzValue]="m.value" [nzLabel]="m.label"></nz-option>
                    </nz-select>
                  </div>
                  <div nz-col [nzSpan]="10">
                    <input nz-input type="number" [(ngModel)]="createForm.periodEndYear" />
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <nz-form-item>
          <nz-form-control>
            <button nz-button nzType="primary" nzSize="large" (click)="createBudget()" [nzLoading]="loading" style="width: 100%; text-transform: uppercase;">
              Creează buget nou
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </div>

  <!-- Budget List View (Edit) -->
  <div *ngIf="currentView === 'edit-list'">
    <div class="budget-header">
      <div>
        <button nz-button (click)="backToLanding()" style="margin-right: 12px;">
          ← Înapoi
        </button>
        <span class="budget-title">Editează Buget</span>
      </div>
      <button nz-button nzType="primary" (click)="goToCreate()"
        [disabled]="budgetGroups.length >= 3"
        nz-tooltip [nzTooltipTitle]="budgetGroups.length >= 3 ? 'Sunt permise maxim 3 bugete' : ''"
        style="text-transform: uppercase;">
        Creează buget nou
      </button>
    </div>

    <nz-table
      #budgetTable
      [nzData]="budgetGroups"
      [nzLoading]="loading"
      nzSize="small"
      [nzShowPagination]="false"
    >
      <thead>
        <tr>
          <th>Nume</th>
          <th>Perioada</th>
          <th>Data creare</th>
          <th>Data actualizării</th>
          <th>Acțiuni</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let group of budgetTable.data">
          <td>{{ group.name }}</td>
          <td>{{ group.period }}</td>
          <td>{{ group.dateCreated | date:'dd.MM.yyyy' }}</td>
          <td>{{ group.dateUpdated | date:'dd.MM.yyyy' }}</td>
          <td>
            <button *ngIf="group.realistic" nz-button nzType="link" (click)="openBudget(group.realistic)">
              Editează Realist
            </button>
            <button *ngIf="group.pessimistic" nz-button nzType="link" (click)="openBudget(group.pessimistic)">
              Editează Pesimist
            </button>
            <button
              nz-button
              nzType="link"
              nzDanger
              nz-popconfirm
              nzPopconfirmTitle="Ești sigur că vrei să ștergi acest buget (ambele variante)?"
              (nzOnConfirm)="deleteBudget(group.realistic?.id || group.pessimistic?.id)"
            >
              Șterge
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- Comparison View -->
  <div *ngIf="currentView === 'comparison'">
    <div class="budget-header">
      <div>
        <button nz-button (click)="readOnly ? backToAdminList() : backToLanding()" style="margin-right: 12px;">
          ← Înapoi
        </button>
        <span class="budget-title">Variații Bugetare</span>
      </div>
    </div>

    <app-budget-comparison
      *ngIf="selectedComparisonGroup"
      [budgetGroup]="selectedComparisonGroup"
      [availableFiles]="userFiles"
      (close)="backToLanding()">
    </app-budget-comparison>
  </div>

  <!-- Budget Editor View -->
  <div *ngIf="currentView === 'editor' && selectedBudget" class="editor-fullheight">
    <div class="budget-header">
      <div>
        <button nz-button (click)="readOnly ? backToAdminList() : backToList()" style="margin-right: 12px;">
          ← Înapoi
        </button>
        <span class="budget-title" style="font-size: 24px; font-weight: 700;">
          {{ readOnly ? 'Vizualizare' : 'Editează' }} Buget {{ selectedBudget.variantType === 'realistic' ? 'Realist' : 'Pesimist' }} — {{ selectedBudget.name }}
        </span>
      </div>
      <div *ngIf="!readOnly">
        <button nz-button (click)="exportExcel()" style="margin-right: 8px;">
          Export Excel
        </button>
        <button nz-button (click)="exportPdf()" style="margin-right: 8px;">
          Export PDF
        </button>
        <button nz-button (click)="openEmailModal()" style="margin-right: 8px;">
          Trimite pe email
        </button>
        <button nz-button nzType="primary" (click)="saveBudget()" [nzLoading]="savingBudget">
          Salvează
        </button>
      </div>
    </div>

    <!-- Monthly Editable Table -->
    <div class="budget-table-wrapper">
      <nz-table
        #editorTable
        [nzData]="cachedUniqueRows"
        [nzLoading]="loading"
        nzSize="small"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        [nzScroll]="{ x: (260 + visibleColumns.length * 130 + 140) + 'px' }"
      >
        <thead>
          <!-- Multi-year header: Row 1 = year groups, Row 2 = month columns -->
          <ng-container *ngIf="hasMultipleYears">
            <tr>
              <th nzLeft nzWidth="260px" [attr.rowspan]="2">Descriere</th>
              <ng-container *ngFor="let yg of yearGroups">
                <th [attr.colspan]="getYearColspan(yg.year)"
                    class="year-group-header text-center"
                    (click)="toggleYear(yg.year)"
                    style="cursor: pointer;">
                  {{ expandedYears.has(yg.year) ? '\u25BC' : '\u25B6' }} {{ yg.year }}
                </th>
              </ng-container>
              <th nzWidth="140px" [attr.rowspan]="2" class="text-right">Total</th>
            </tr>
            <tr>
              <ng-container *ngFor="let col of visibleColumns">
                <th nzWidth="130px" class="text-right">{{ col.isYearTotal ? 'Total' : col.label }}</th>
              </ng-container>
            </tr>
          </ng-container>
          <!-- Single-year header: simple flat layout -->
          <ng-container *ngIf="!hasMultipleYears">
            <tr>
              <th nzLeft nzWidth="260px">Descriere</th>
              <th *ngFor="let col of visibleColumns" nzWidth="130px" class="text-right">
                {{ col.label }}
              </th>
              <th nzWidth="140px" class="text-right">Total</th>
            </tr>
          </ng-container>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of editorTable.data">
            <!-- Category / Summary row -->
            <tr [class.computed-row]="row.isComputed">
              <td nzLeft *ngIf="!row.isComputed && row.sortOrder !== 3">
                <button (click)="onExpandChange(row.sortOrder, !expandSet.has(row.sortOrder))"
                        class="expand-toggle">
                  {{ expandSet.has(row.sortOrder) ? '−' : '+' }}
                </button>
                {{ row.description }}
              </td>
              <td nzLeft *ngIf="!row.isComputed && row.sortOrder === 3">
                {{ row.description }}
              </td>
              <td nzLeft *ngIf="row.isComputed">
                <strong>{{ row.description }}</strong>
              </td>
              <!-- Editable cells for Cheltuieli cu salariile (sort_order 3) -->
              <ng-container *ngIf="!row.isComputed && row.sortOrder === 3">
                <td *ngFor="let col of visibleColumns" class="text-right">
                  <ng-container *ngIf="!col.isYearTotal">
                    <input
                      nz-input
                      class="budget-input account-input"
                      [disabled]="readOnly"
                      [value]="formatNumber(getLineValue(row.sortOrder, col.month, col.year)?.value)"
                      (blur)="onLineValueChange(row.sortOrder, col.month, col.year, parseNumber($event.target.value)); $event.target.value = formatNumber(parseNumber($event.target.value))"
                    />
                  </ng-container>
                  <span *ngIf="col.isYearTotal" [class.negative-value]="getYearTotal(row.sortOrder, col.year) < 0">
                    {{ getYearTotal(row.sortOrder, col.year) | number:'1.0-0':'ro' }}
                  </span>
                </td>
                <td class="text-right">
                  <strong [class.negative-value]="getRowTotal(row.sortOrder) < 0">
                    {{ getRowTotal(row.sortOrder) | number:'1.0-0':'ro' }}
                  </strong>
                </td>
              </ng-container>
              <!-- Read-only cells for all other rows -->
              <ng-container *ngIf="row.isComputed || row.sortOrder !== 3">
                <td *ngFor="let col of visibleColumns" class="text-right">
                  <ng-container *ngIf="!col.isYearTotal">
                    <span [class.negative-value]="getLineValue(row.sortOrder, col.month, col.year)?.value < 0">
                      <ng-container *ngIf="row.description.startsWith('%')">{{ getLineValue(row.sortOrder, col.month, col.year)?.value | number:'1.1-1':'ro' }} %</ng-container>
                      <ng-container *ngIf="!row.description.startsWith('%')">{{ getLineValue(row.sortOrder, col.month, col.year)?.value | number:'1.0-0':'ro' }}</ng-container>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="col.isYearTotal">
                    <span *ngIf="row.description.startsWith('%')" class="no-data">—</span>
                    <span *ngIf="!row.description.startsWith('%')" [class.negative-value]="getYearTotal(row.sortOrder, col.year) < 0">
                      {{ getYearTotal(row.sortOrder, col.year) | number:'1.0-0':'ro' }}
                    </span>
                  </ng-container>
                </td>
                <td class="text-right">
                  <strong [class.negative-value]="getRowTotal(row.sortOrder) < 0">
                    <ng-container *ngIf="row.description.startsWith('%')">{{ getRowTotal(row.sortOrder) | number:'1.1-1':'ro' }} %</ng-container>
                    <ng-container *ngIf="!row.description.startsWith('%')">{{ getRowTotal(row.sortOrder) | number:'1.0-0':'ro' }}</ng-container>
                  </strong>
                </td>
              </ng-container>
            </tr>
            <!-- Account detail rows (inline in parent table, sharing columns & scroll) -->
            <ng-container *ngIf="row.sortOrder !== 3 && expandSet.has(row.sortOrder) && hasDetailAccounts(row.sortOrder)">
              <tr *ngFor="let acct of getDetailAccounts(row.sortOrder)" class="account-detail-row">
                <td nzLeft style="padding-left: 40px;">
                  <span class="detail-account-code">{{ acct.accountCode }}</span>
                  <span class="detail-account-desc">{{ acct.accountDescription }}</span>
                </td>
                <td *ngFor="let col of visibleColumns" class="text-right">
                  <ng-container *ngIf="!col.isYearTotal">
                    <ng-container *ngIf="isEditableAccountLine(acct)">
                      <input
                        nz-input
                        class="budget-input account-input"
                        [disabled]="readOnly"
                        [value]="formatNumber(getAccountValue(acct, col.month, col.year))"
                        (blur)="onAccountValueChange(row.sortOrder, acct.accountCode, col.month, col.year, parseNumber($event.target.value)); $event.target.value = formatNumber(parseNumber($event.target.value))"
                      />
                    </ng-container>
                    <span *ngIf="!isEditableAccountLine(acct)" class="no-data">—</span>
                  </ng-container>
                  <ng-container *ngIf="col.isYearTotal">
                    <span *ngIf="isEditableAccountLine(acct)">{{ getAccountYearTotal(acct, col.year) | number:'1.0-0':'ro' }}</span>
                    <span *ngIf="!isEditableAccountLine(acct)" class="no-data">—</span>
                  </ng-container>
                </td>
                <td class="text-right acct-total">
                  <ng-container *ngIf="isEditableAccountLine(acct)">
                    {{ getAccountTotal(acct) | number:'1.0-0':'ro' }}
                  </ng-container>
                  <ng-container *ngIf="!isEditableAccountLine(acct)">
                    {{ acct.value | number:'1.0-0':'ro' }}
                  </ng-container>
                </td>
              </tr>
              <!-- Add account row -->
              <tr class="account-detail-row add-account-row" *ngIf="!row.isComputed && !readOnly">
                <td nzLeft style="padding-left: 40px;" [attr.colspan]="visibleColumns.length + 2">
                  <ng-container *ngIf="addAccountSortOrder !== row.sortOrder">
                    <button nz-button nzType="dashed" nzSize="small" (click)="showAddAccountForm(row.sortOrder)">
                      {{ getAddButtonLabel(row.sortOrder) }}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="addAccountSortOrder === row.sortOrder">
                    <div class="add-account-inline">
                      <nz-select
                        [(ngModel)]="addAccountCode"
                        (ngModelChange)="onAddAccountSelect($event)"
                        nzPlaceHolder="Selectează"
                        nzShowSearch
                        nzSize="small"
                        [nzLoading]="loadingAvailableAccounts"
                        [nzDropdownMatchSelectWidth]="false"
                        style="width: 400px;"
                      >
                        <nz-option
                          *ngFor="let a of availableAccounts"
                          [nzValue]="a.accountCode"
                          [nzLabel]="a.accountDescription"
                        ></nz-option>
                      </nz-select>
                      <button nz-button nzType="primary" nzSize="small" (click)="confirmAddAccount()" [nzLoading]="addingAccount" style="margin-left: 8px;">
                        Adaugă
                      </button>
                      <button nz-button nzSize="small" (click)="cancelAddAccount()" style="margin-left: 4px;">Anulează</button>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
            <!-- Show add button even when no accounts exist yet -->
            <ng-container *ngIf="row.sortOrder !== 3 && expandSet.has(row.sortOrder) && !hasDetailAccounts(row.sortOrder) && !row.isComputed && !readOnly">
              <tr class="account-detail-row add-account-row">
                <td nzLeft style="padding-left: 40px;" [attr.colspan]="visibleColumns.length + 2">
                  <ng-container *ngIf="addAccountSortOrder !== row.sortOrder">
                    <button nz-button nzType="dashed" nzSize="small" (click)="showAddAccountForm(row.sortOrder)">
                      {{ getAddButtonLabel(row.sortOrder) }}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="addAccountSortOrder === row.sortOrder">
                    <div class="add-account-inline">
                      <nz-select
                        [(ngModel)]="addAccountCode"
                        (ngModelChange)="onAddAccountSelect($event)"
                        nzPlaceHolder="Selectează"
                        nzShowSearch
                        nzSize="small"
                        [nzLoading]="loadingAvailableAccounts"
                        [nzDropdownMatchSelectWidth]="false"
                        style="width: 400px;"
                      >
                        <nz-option
                          *ngFor="let a of availableAccounts"
                          [nzValue]="a.accountCode"
                          [nzLabel]="a.accountDescription"
                        ></nz-option>
                      </nz-select>
                      <button nz-button nzType="primary" nzSize="small" (click)="confirmAddAccount()" [nzLoading]="addingAccount" style="margin-left: 8px;">
                        Adaugă
                      </button>
                      <button nz-button nzSize="small" (click)="cancelAddAccount()" style="margin-left: 4px;">Anulează</button>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </nz-table>
    </div>

    <!-- Budget guidance info card -->
    <div *ngIf="budgetGuidanceContent" class="guidance-card" style="margin-top: 24px;">
      <nz-collapse>
        <nz-collapse-panel
          nzHeader="Informații suplimentare pentru întocmirea bugetului"
          [nzActive]="false">
          <div [innerHTML]="budgetGuidanceContent"></div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <!-- Send by Email Modal -->
    <nz-modal
      [(nzVisible)]="showEmailModal"
      nzTitle="Trimite bugetul pe email"
      (nzOnCancel)="showEmailModal = false"
      (nzOnOk)="sendByEmail()"
      nzOkText="Trimite"
      [nzOkLoading]="sendingEmail"
      [nzWidth]="450"
    >
      <ng-container *nzModalContent>
        <nz-form-item>
          <nz-form-label>Adresa de email</nz-form-label>
          <nz-form-control>
            <input nz-input [(ngModel)]="emailAddress" placeholder="email@exemplu.ro" type="email" />
          </nz-form-control>
        </nz-form-item>
      </ng-container>
    </nz-modal>
  </div>

</div>
